import { DEFAULT_LANGUAGE_LABEL } from "@/constant/Languages/language";

export const BASE_IMPORT_DATA = {
  SPORTS: {
    dataName: "Sports",
    codeColumnName: "Sport ID",
    columnNames: ["Status", "Sport ID", `Sport Name ${DEFAULT_LANGUAGE_LABEL}`],
  },
  TEAM_GROUPS: {
    dataName: "Team Groups",
    codeColumnName: "Team Group ID",
    columnNames: [
      "Status",
      "Sport ID",
      "Team Group ID",
      `Team Group Name ${DEFAULT_LANGUAGE_LABEL}`,
    ],
  },
  TEAMS: {
    dataName: "Teams",
    codeColumnName: "Team ID",
    // columnNames: ["MPL Status", "Show Profile?", "Sport ID", "Team ID", "Club / National Team", "City", "Country", "Foundation Year", "Stadium Name", "Field Length", "Anthem Name", "Mascot 1", "Rival 1 Team", `Team Name ${DEFAULT_LANGUAGE_LABEL}`]
    columnNames: [
      "MPL Status",
      "Show Profile?",
      "Sport ID",
      "Team ID",
      "Club / National Team",
      `Team Name ${DEFAULT_LANGUAGE_LABEL}`,
    ],
  },
  COMPETITION_GROUPS: {
    dataName: "Competition Groups",
    codeColumnName: "Competition Group ID",
    columnNames: [
      "Status",
      "Sport ID",
      "Competition Group ID",
      `Competition Group Name ${DEFAULT_LANGUAGE_LABEL}`,
    ],
  },
  COMPETITIONS: {
    dataName: "Competitions",
    codeColumnName: "Competition ID",
    columnNames: [
      "Competition ID",
      `Competition Name ${DEFAULT_LANGUAGE_LABEL}`,
    ],
  },
  EVENTS: {
    dataName: "Events",
    shouldBeUniqueCompositeColumns: ["Competition ID", "Term ID"],
    columns: ["Show Profile?", "Competition ID", "Term ID"],
    enableAddMode: false,
  },

  BRANDS: {
    dataName: "Brands",
    codeColumnName: "Brand ID",
    columnNames: ["Brand ID", "Brand"],
  },
  PRODUCT_GROUPS: {
    dataName: "Product Groups",
    codeColumnName: "Product Group ID",
    columnNames: [
      "Status",
      "Product Group ID",
      `Product Group Name ${DEFAULT_LANGUAGE_LABEL}`,
    ],
  },
  PRODUCT_CATEGORIES: {
    dataName: "Product Categories",
    codeColumnName: "Product Category ID",
    columnNames: [
      "Product Category ID",
      `Product Category Name ${DEFAULT_LANGUAGE_LABEL}`,
    ],
  },
  PRODUCTS: {
    dataName: "Products",
    codeColumnName: "Product ID",
    columnNames: [
      "Sport ID",
      "Product ID",
      `Product Name ${DEFAULT_LANGUAGE_LABEL}`,
      "Product Class ID",
    ],
  },
  EDITIONS: {
    dataName: "Editions",
    codeColumnName: "Edition ID",
    columnNames: ["Edition ID", `Edition Name ${DEFAULT_LANGUAGE_LABEL}`],
  },
  TERMS: {
    dataName: "Terms",
    codeColumnName: "Term ID",
    columnNames: ["Term ID", "Term", "Status"],
  },
  VERSIONS: {
    dataName: "Versions",
    codeColumnName: "Version ID",
    columnNames: ["Version ID", `Version Name ${DEFAULT_LANGUAGE_LABEL}`],
  },
  GENDERS: {
    dataName: "Genders",
    codeColumnName: "Gender ID",
    columnNames: ["Gender ID", `Gender Name ${DEFAULT_LANGUAGE_LABEL}`],
  },
  PRODUCT_SIZES: {
    dataName: "Sizes",
    codeColumnName: "Size ID",
    columnNames: ["Size ID", `Size Name ${DEFAULT_LANGUAGE_LABEL}`],
  },
  CONDITIONS: {
    dataName: "Conditions",
    codeColumnName: "Condition ID",
    columnNames: ["Condition ID", `Condition Name ${DEFAULT_LANGUAGE_LABEL}`],
  },
  MATERIALS: {
    dataName: "Materials",
    codeColumnName: "Material ID",
    columnNames: ["Material ID", `Material Name ${DEFAULT_LANGUAGE_LABEL}`],
  },
};
